import { RevampArticleStyles } from 'components/feature/Article/RevampArticle.styles'
import { parseLatexInText } from 'components/feature/Chat/SchoolGPT/SchoolGPTTexts'
import _useTranslation from 'lib/hooks/_useTranslation'
import ReactMarkdown from 'react-markdown'
import theme from 'stories/utils/theme'
import SectionContainer from 'stories/V1/layouts/SectionContainer'
import styled from 'styled-components'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    article {
        max-width: 1024px;
    }
`

interface Props {
    bibliography: string | null
    furtherResearch: string | null
    isDarkTheme: boolean
}

const BibliograghyFutherResearchComponent = ({ bibliography, furtherResearch, isDarkTheme }: Props) => {
    const { t: tKnows } = _useTranslation('knows')
    return (
        <Container>
            <RevampArticleStyles isDarkTheme={isDarkTheme}>
                {bibliography ? (
                    <SectionContainer
                        title={tKnows('knows/bibliographySectionTitle')}
                        backgroundColor={theme.colors.darkBlack}
                    >
                        <ReactMarkdown
                            components={{
                                p: ({ children }) => <p>{parseLatexInText(children)}</p>,
                                li: ({ children }) => <li>{parseLatexInText(children)}</li>,
                            }}
                        >
                            {bibliography}
                        </ReactMarkdown>
                    </SectionContainer>
                ) : null}
                {furtherResearch ? (
                    <SectionContainer
                        title={tKnows('knows/furtherResearchSectionTitle')}
                        backgroundColor={theme.colors.darkBlack}
                    >
                        <ReactMarkdown
                            components={{
                                p: ({ children }) => <p>{parseLatexInText(children)}</p>,
                                li: ({ children }) => <li>{parseLatexInText(children)}</li>,
                            }}
                        >
                            {furtherResearch}
                        </ReactMarkdown>
                    </SectionContainer>
                ) : null}
            </RevampArticleStyles>
        </Container>
    )
}

export default BibliograghyFutherResearchComponent
